import { cn } from '@/utils'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useCallback, useEffect, useRef, useState } from 'react'

export type ScrollPosition = {
  isAtTop: boolean
  isAtBottom: boolean
}

const ScrollButton = ({
  direction,
  onClick,
  className,
  disabled,
}: {
  direction: 'up' | 'down'
  onClick: () => void
  className?: string
  disabled?: boolean
}) => {
  const [isHovering, setIsHovering] = useState(false)
  const scrollInterval = useRef<NodeJS.Timeout>()

  const startScrolling = useCallback(() => {
    if (disabled) return
    setIsHovering(true)
    scrollInterval.current = setInterval(() => {
      const container = document.querySelector('.picker-content')
      if (container) {
        container.scrollTop += direction === 'up' ? -10 : 10
      }
    }, 16) // ~60fps
  }, [direction, disabled])

  const stopScrolling = useCallback(() => {
    setIsHovering(false)
    if (scrollInterval.current) {
      clearInterval(scrollInterval.current)
    }
  }, [])

  useEffect(() => {
    return () => {
      if (scrollInterval.current) {
        clearInterval(scrollInterval.current)
      }
    }
  }, [])

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={startScrolling}
      onMouseLeave={stopScrolling}
      className={cn(
        'flex cursor-default items-center justify-center py-1 w-full',
        disabled && 'opacity-50 cursor-not-allowed',
        isHovering && '',
        className
      )}
    >
      {direction === 'up' ? (
        <ChevronUp className="h-4 w-4" />
      ) : (
        <ChevronDown className="h-4 w-4" />
      )}
    </button>
  )
}

export default ScrollButton
